import { Injectable } from '@angular/core';
import { ApiBaseService } from './api.base.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class programService extends ApiBaseService {
  constructor(public http: HttpClient) {
    super(http, '/programs');
  }

  checkNameExist(name: string, userId?: string): Observable<any> {
    const params = { name };
    const id = userId ? userId : null;
    return this.http.get(`${environment.apiUrl}/programs/name/${id}`, {
      params,
    });
  }
}
